/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function MediaAcceptProfilesImageValidatorsSearchViewController(this: JS5Object, MediaAcceptProfileService: JS5Object,
                                                                uiGridConstants: JS5Object, $location: JS5Object,
                                                                NavbarUtilService: JS5Object, ModalService: JS5Object,
                                                                $routeParams: JS5Object, BreadcrumbService: JS5Object) {
    const getData = () => {
        MediaAcceptProfileService.getValidators(
            $routeParams.id,
            this.showHidden,
            {validatorType: 'IMAGE'},
            this.showHidden
        ).then((validators: JS5Object) => {
            this.gridOptions.data = validators;
            this.gridApi.selection.clearSelectedRows();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const addMapBreadCrumb = () => {
        BreadcrumbService.addBreadcrumb({
            name: this.mediaAcceptProfile.name,
            location: `/system/templates/media/acceptProfiles/edit/${this.mediaAcceptProfile.id}`,
            params: {editView: 'image'}
        });
    };

    const navigateToEditView = (imageValidator: JS5Object) => {
        addMapBreadCrumb();
        if (_.isNil(imageValidator)) {
            $location.url(`system/templates/media/acceptProfiles/edit/${$routeParams.id}/imageValidators/edit/${_.get(_.first(this.gridApi.selection.getSelectedRows()), 'id')}`);
        } else {
            $location.url(`system/templates/media/acceptProfiles/edit/${$routeParams.id}/imageValidators/edit/${_.get(imageValidator, 'id')}`);
        }
    };
    const navigateToEditViewToCreateImageValidator = () => {
        addMapBreadCrumb();
        $location.url(`system/templates/media/acceptProfiles/edit/${$routeParams.id}/imageValidators/edit/-1`);
    };
    const toggleVisibility = (message: string) => {
        ModalService.showMessageModal({
            messageText: message,
            pullCancelLeft: true,
            title: 'Hide Image Validator',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {
            this.loadingIndicator.show = true;
            const imageValidatorId = _.get(_.first(this.gridApi.selection.getSelectedRows()), 'id');
            MediaAcceptProfileService.toggleValidatorVisibility(imageValidatorId).then(() => {
                getData();
            }).finally(() => {
                this.setFormPristine();
                this.loadingIndicator.show = false;
            })
        });
    };


    const columnDefinitions = [
        {
            field: 'trackNumber',
            type: 'number',
            width: 150,
            displayName: 'Track Number',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'format',
            displayName: 'Format',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'bitDepth',
            displayName: 'Bit Depth',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        data: [],
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };

    this.onRowDblClick = (row: JS5Object) => {
        if (!_.get(row.entity, 'hidden')) {
            navigateToEditView(row.entity);
        }
    };

    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => true,
            onClick: navigateToEditViewToCreateImageValidator
        },
        {
            label: 'Edit',
            enabled: () => this.gridApi.selection.getSelectedCount() && !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
            onClick: navigateToEditView
        },
        {
            label: 'Hide',
            enabled: () => _.first(this.gridApi.selection.getSelectedRows()) && !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
            onClick: () => toggleVisibility('Are you sure that you want to hide this Image Validator?')
        },
        {
            label: 'Unhide',
            enabled: () => _.first(this.gridApi.selection.getSelectedRows()) && _.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
            onClick: () => toggleVisibility('Are you sure that you want to unhide this Image Validator?')
        }
    ];


    this.toolbarCheckboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: (newState: boolean) => {
                this.showHidden = newState;
                $location.search('showHidden', newState);
                getData();
                this.setFormPristine();
            },
            isChecked: this.showHidden
        }
    ];

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        this.showHidden = $location.search().showHidden;
        this.toolbarCheckboxDefs[0].isChecked = this.showHidden;

        getData();
    };

}

angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesImageValidatorsSearchView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/components/validators/image/searchView/media-accept-profiles-image-validators-search-view-template.html',
    controller: MediaAcceptProfilesImageValidatorsSearchViewController,
    bindings: {
        setFormPristine: '&',
        mediaAcceptProfile: '<'
    }
});
